import Cookie from 'js-cookie';
var DOMAIN = '.collegeboard.org';
var ORGID_COOKIE = 'apfymSelectedOrgId';
var LOGGEDIN_COOKIE = 'apfymLoggedInToken';
export var getLoginToken = function getLoginToken() {
  return Cookie.get('cb_login');
};
export var setSelectedOrgId = function setSelectedOrgId(orgId) {
  var domain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DOMAIN;
  if (orgId) Cookie.set(ORGID_COOKIE, orgId, {
    domain: domain
  });
};
export var getSelectedOrgId = function getSelectedOrgId() {
  var orgId = Cookie.get(ORGID_COOKIE);
  return orgId ? parseInt(orgId, 10) : null;
};
export var removeSelectedOrgId = function removeSelectedOrgId() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DOMAIN;
  return Cookie.remove(ORGID_COOKIE, {
    domain: domain
  });
};
export var setLoggedInToken = function setLoggedInToken() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DOMAIN;
  return Cookie.set(LOGGEDIN_COOKIE, getLoginToken(), {
    domain: domain
  });
};
export var isNewLoggedInSession = function isNewLoggedInSession() {
  return Cookie.get(LOGGEDIN_COOKIE) !== getLoginToken();
};